if (document.getElementById('vue-account-documents')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-account-documents',
		data: {
			filters: {
				partners: {
					options: [],
					model: {}
				}
			},
			documents: {},
			searchValue: '',
			activeTab: 0,
			canDownloadHomeCertificate: true,
			tabs: [
				{
					name: 'administratif',
					label: gettext('Administratif'),
					value: 0
				},
				{
					name: 'residence',
					label: gettext('Ma résidence'),
					value: 1
				}
			],
			loading: true,
			user: {},
			notifications: []
		},
		created() { },
		mounted() {
			this.getDocuments();
			this.setUser();
		},
		computed: {
			endpoint() {
				let endpoint;
				window.site_id === 4 && (endpoint = 'partner-documents');
				window.site_id === 1 && (endpoint = 'documents');
				return endpoint;
			},
			endpointDocumentsResidences() {
				let endpoint = 'documents-residences';
				return endpoint;
			},
			endpointParams() {
				return {
					limit: 1000,
					...(window.site_id === 1 && {
						document_type__in: 'receipt,notice,lease,charges_regularisation,home_certificate',
						scepia_sync: 1
					})
				};
			},
			endpointParamsDocumentsResidences() {
				return {
					limit: 1000
				};
			}
		},
		watch: {
			searchValue: {
				immidiate: true,
				handler: debounce(function () {
					this.search();
				}, 300)
			}
		},
		methods: {
			setUser() {
				this.get('residents/me').then((response) => {
					this.user = response.data
				});
			},
			onChangeTab(index) {
				this.loading = true;
				this.activeTab = index;
				this.documents = [];
				if (this.activeTab === 0) {
					this.getDocuments();
				} else {
					this.getDocumentsResidences();
				}
			},
			getDocuments() {
				this.get(this.endpoint, this.endpointParams)
					.then((response) => {
						this.documents = response.data.results;
						this.loading = false;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getDocumentsResidences() {
				this.get(this.endpointDocumentsResidences, this.endpointParamsDocumentsResidences)
					.then((response) => {
						this.documents = response.data.results;
						this.loading = false;
					})
					.catch((error) => {
						// console.log(error);
					});
			},
			getHomeCertificate() {
				this.get('users/me').then((response) => {
					this.get(`residents/${response.data.id}/home-certificate`, {})
						.then((response) => {
							this.canDownloadHomeCertificate = false;
						})
						.catch((error) => {
							// console.log(error);
						});
				});

			},
			search() {
				console.log(this.activeTab)
				if (this.activeTab === 0) {
					this.get(this.endpoint, {
						...(window.site_id === 4 && { name__icontains: this.searchValue }),
						...(window.site_id === 1 && { search_field: this.searchValue }),
						...this.endpointParams
					})
						.then((response) => {
							this.documents = response.data.results;
						})
						.catch((error) => {
							// console.log(error);
						});
				} else if (this.activeTab === 1) {
					this.get(this.endpointDocumentsResidences, {
						search: this.searchValue,
						...this.endpointParamsDocumentsResidences
					})
						.then((response) => {
							this.documents = response.data.results;
						})
						.catch((error) => {
							// console.log(error);
						});
				}
			}
		}
	});
}
